import { section } from "@/js/glow";
import { qs } from "@fluorescent/dom";

section("products-slider", {
  onLoad() {
    const { mobileProductsPerView, tabletProductsPerView, desktopProductsPerView, mobileSpaceBetween, desktopSpaceBetween, customClass } = this.container.dataset;
    this.mobilePerView = parseFloat(mobileProductsPerView);
    this.tabletPerView = parseFloat(tabletProductsPerView);
    this.desktopPerView = parseFloat(desktopProductsPerView);
    this.mobileSpace = parseFloat(mobileSpaceBetween);
    this.desktopSpace = parseFloat(desktopSpaceBetween);
    
    this.productSlider = qs(`.${customClass} .prod-slider.swiper`);

    if (this.productSlider) {
      this._initCarousel({
        container: `.${customClass} .prod-slider.swiper`,
        navigationNext: `.${customClass} .prod-slider__navigation [data-next]`,
        navigationPrev: `.${customClass} .prod-slider__navigation [data-prev]`,
        pagination: `.${customClass} .prod-slider__pagination`,
        mobilePerView: this.mobilePerView,
        tabletPerView: this.tabletPerView,
        perView: this.desktopPerView,
        mobileSpace: this.mobileSpace,
        desktopSpace: this.desktopSpace
      });
    }
  },

  _initCarousel(selectors) {
    const loadSwiper = () => {
      import(/* @vite-ignore */ flu.chunks.swiper).then(({ Swiper, Navigation, Pagination }) => {
        const swiperOptions = {
          modules: [Navigation, Pagination],
          slidesPerView: selectors.mobilePerView,
          spaceBetween: selectors.mobileSpace,
          navigation: {
            nextEl: selectors.navigationNext,
            prevEl: selectors.navigationPrev,
          },
          pagination: {
            el: selectors.pagination,
            // dynamicBullets: true,
            type: "bullets",
            clickable: true,
          },
          breakpoints: {
            720: {
              spaceBetween: selectors.mobileSpace,
              slidesPerView: selectors.tabletPerView,
            },
            1024: {
              spaceBetween: selectors.desktopSpace,
              slidesPerView: selectors.perView,
            },
          },
        };
    
        new Swiper(selectors.container, swiperOptions);
      });
    };

    loadSwiper();
  },
});